export default "__VITE_ASSET__B451sjwO__"